module.exports = __webpack_public_path__ + "static/media/Aurorus_gaussian2.e5f7f2da.png";